import { render, staticRenderFns } from "./CertificationAgencyUser.vue?vue&type=template&id=fddf1082&"
import script from "./CertificationAgencyUser.vue?vue&type=script&lang=js&"
export * from "./CertificationAgencyUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports